import React, { FunctionComponent } from 'react'
import Svg, { Path, Rect } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { ThemeType } from '../../utils'

type Props = {
  size?: number | string
}

export const AuroraCareNavigatorSpotIllustration: FunctionComponent<Props> = ({ size = 96 }) => {
  const { colors } = useTheme() as ThemeType
  const { auroraIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 96 96' fill='none'>
      <Rect width='96' height='96' rx='48' fill='white' fillOpacity='0.4' />
      <Path
        d='M71.1256 29.7478V62.7102C71.1256 63.4167 70.5742 63.9912 69.8908 63.9912H26.1391C25.459 63.9912 24.9043 63.4134 24.9043 62.7102V29.7478C24.9043 29.0413 25.4557 28.4668 26.1391 28.4668H69.8908C70.5709 28.4668 71.1256 29.0413 71.1256 29.7478Z'
        fill={auroraIllustration.primary.fill}
      />
      <Path
        d='M58.7309 62.0635H37.7927C37.7861 57.8573 37.6309 51.9806 40.3184 49.5078C41.3914 48.5173 43.8048 46.8996 45.0296 47.3882C49.3711 49.1215 50.8304 47.8537 52.5241 47.441C54.1814 47.0382 56.5817 49.072 57.4467 50.353C59.0644 52.7433 58.83 58.1346 58.7309 62.0635Z'
        fill={auroraIllustration.secondary.fill}
      />
      <Path
        d='M54.269 40.4181C54.269 43.472 51.9282 46.2288 49.0427 46.2288C46.1572 46.2288 43.8164 43.472 43.8164 40.4181C43.8164 37.3642 46.1572 34.6074 49.0427 34.6074C51.9282 34.6074 54.269 37.3642 54.269 40.4181Z'
        fill={auroraIllustration.secondary.fill}
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.9717 63.8594C16.9717 61.963 18.5089 60.4258 20.4053 60.4258H75.6265C77.5228 60.4258 79.0601 61.963 79.0601 63.8594C79.0601 65.7557 77.5228 67.2929 75.6265 67.2929H20.4053C18.5089 67.2929 16.9717 65.7557 16.9717 63.8594Z'
        fill={auroraIllustration.secondary.fill}
      />
    </Svg>
  )
}
